// extracted by mini-css-extract-plugin
export default {"container":"XqK7Ko"};